import React, { FC, useMemo } from 'react';

import ComponentTypesIconWrapper from 'components/componentTypesIcon/ComponentTypesIconWrapper';
import useVariantsByComponentIdQuery from 'hooks/components/useVariantsByComponentIdQuery';
import styled from 'styled-components';

import { ComponentTypeTransformed } from 'models/component-types-model';
import { VariantElement } from 'models/editor.model';
import { VariantType, VariantWithLabel } from 'models/variant.model';

interface VariantContentProps {
    child: VariantElement;
    componentTypes?: ComponentTypeTransformed;
}

const VariantContent: FC<VariantContentProps> = ({ child, componentTypes }) => {
    const id = child.id;
    const variantType = child.variantType;
    const componentType = componentTypes?.map[variantType];

    const { data, isLoading } = useVariantsByComponentIdQuery(id);

    const varinat = useMemo<VariantWithLabel | undefined>(() => {
        if (!isLoading && data?.length) {
            return data[0];
        }
        return undefined;
    }, [data, isLoading]);

    const content = useMemo<string>(() => varinat?.content ?? '', [varinat]);

    if (variantType == VariantType.Image) {
        return (
            <VariantSection
                style={{
                    color: componentType?.base_color,
                }}
            >
                <ImageSection src={content}></ImageSection>
            </VariantSection>
        );
    }

    return (
        <VariantSection
            style={{
                color: componentType?.base_color,
            }}
        >
            <ComponentTypesIconWrapper dataKey={componentType?.data_key} />
            {content}
        </VariantSection>
    );
};

const VariantSection = styled.div({
    justifyContent: 'center',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    margin: '0 2px',
});

const ImageSection = styled.img({
    height: '50px',
    width: '50px',
});

export default VariantContent;
